<template>
    <md-content class="card md-layout-item md-size-100 md-small-size-100">
        <md-card class="md-form-card md-mt-70 md-form-input">
            <span class="preferencesInfo">
                Tu możesz zawęzić okres emisji wybranego produktu lub dodać kilka okresów w ramach kampanii. Pola nieobowiązkowe
            </span>
            <md-card-content>
                <md-card-actions class="add-interval-button">
                    <md-button class="md-subtitle-btn" @click="addTimeInterval = !addTimeInterval">
                        {{ $t('views.order.product.buttons.addTimeInterval') }}
                    </md-button>
                </md-card-actions>
                <md-table v-model="form.productTimeIntervals">
                    <md-table-row slot="md-table-row" slot-scope="{ item, index }" v-show="item.validFrom"
                                  @mouseover="currentHoverIndex = index" @mouseleave="currentHoverIndex = null">
                        <md-table-cell :md-label="$t('views.order.product.table.validFrom')">{{ item.validFrom }}</md-table-cell>
                        <md-table-cell :md-label="$t('views.order.product.table.validTo')">{{ item.validTo }}</md-table-cell>
                        <md-table-cell class="fixed-item-width">
                            <div class="actions-products" v-if="currentHoverIndex === index">
                                <md-button class="md-icon-button" @click="deleteProductTimeInterval(index)">
                                    <md-icon>delete</md-icon>
                                    <md-tooltip md-direction="top">{{ $t('delete') }}</md-tooltip>
                                </md-button>
                            </div>
                        </md-table-cell>
                    </md-table-row>
                </md-table>
                <template v-if="addTimeInterval">
                    <div class="md-layout-item md-small-size-100">
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-small-size-100 md-size-30">
                                <md-datepicker class="md-required" v-model="$v.intervalForm.validFrom.$model" :disabled="sending" :md-immediately="true"
                                               :class="getValidationClass('validFrom', $v.intervalForm)" :md-disabled-dates="disabledDatesValidFrom">
                                    <label>{{ $t('views.order.campaign.form.label.validFrom') }}</label>
                                    <span class="md-error" v-if="!$v.intervalForm.validFrom.required">{{ $t('validation.required') }}</span>
                                    <span class="md-error" v-else-if="!$v.intervalForm.validFrom.isSameOrAfterDate">{{ $t('views.order.product.validation.isSameOrAfterDate') }}</span>
                                    <span class="md-error" v-else-if="!$v.intervalForm.validFrom.isSameOrBefore">{{ $t('validation.isSameOrBefore', {0: $t('views.order.campaign.form.label.validTo')}) }}</span>
                                </md-datepicker>
                            </div>

                            <div class="md-layout-item md-small-size-100 md-size-30">
                                <md-datepicker class="md-required" v-model="$v.intervalForm.validTo.$model"
                                :disabled="sending" :md-immediately="true"
                                               :class="getValidationClass('validTo', $v.intervalForm)" :md-disabled-dates="disabledDatesValidTo">
                                    <label>{{ $t('views.order.campaign.form.label.validTo') }}</label>
                                    <span class="md-error" v-if="!$v.intervalForm.validTo.required">{{ $t('validation.required') }}</span>
                                    <span class="md-error" v-else-if="!$v.intervalForm.validTo.isSameOrBeforeDate">{{ $t('views.order.product.validation.isSameOrBeforeDate') }}</span>
                                    <span class="md-error" v-else-if="!$v.intervalForm.validTo.isSameOrAfter">{{ $t('validation.isSameOrAfter', {0: $t('views.order.campaign.form.label.validFrom')}) }}</span>
                                </md-datepicker>
                            </div>

                            <div class="md-layout-item md-small-size-100">
                                <md-field>
                                    <md-button class="md-accent" @click="addInterval">{{ $t('views.order.product.buttons.confirm') }}</md-button>
                                </md-field>
                            </div>
                        </div>
                    </div>
                </template>
            </md-card-content>

            <md-card-actions>
                <md-button class="md-primary" @click="$emit('cancel')">{{ $t('views.order.product.buttons.cancel') }}</md-button>
                <md-button class="md-accent md-raised" @click="addInterval(); goToNextStep()">{{ $t(`views.order.product.buttons.${editMode ? 'editProduct' : 'addProduct'}`) }}</md-button>
            </md-card-actions>
        </md-card>
    </md-content>
</template>

<script>
    import {isAfter, isBefore, isDate, isSameOrAfter, isSameOrBefore} from '@/validators/validators';
    import {required, minLength} from 'vuelidate/lib/validators';
    import serverSideValidationErrors from '@/mixins/serverSideValidationErrors';

    export default {
    name: "OrderProductStep3",
    mixins: [serverSideValidationErrors],
    props: {
        currentOrder: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        editMode: {
            type: Boolean,
            required: true
        },
        datesRange: {
            type: Object,
            required: true
        }
    },
    data: function () {
        return {
            minDate: this.datesRange.min,
            maxDate: this.datesRange.max,
            sending: false,
            addTimeInterval: false,
            currentHoverIndex: null,
            form: {
                productTimeIntervals: [
                    {},
                    ...this.value.productTimeIntervals
                ]
            },
            intervalForm: {
                validFrom: null,
                validTo: null
            },
            disabledDatesValidFrom: date => {
                return this.$moment(this.minDate, "DD.MM.YYYY") > this.$moment(date).toDate() ||
                    this.$moment(this.maxDate, "DD.MM.YYYY").add(1, "day") < this.$moment(date).toDate() ||
                    this.disable(date);
            },
            disabledDatesValidTo: date => {
                return this.$moment(this.minDate, "DD.MM.YYYY") > this.$moment(date).toDate() ||
                    this.$moment(this.maxDate, "DD.MM.YYYY").add(1, "day") < this.$moment(date).toDate() ||
                    this.$moment(date).toDate() < this.$moment(this.intervalForm.validFrom, "DD.MM.YYYY") ||
                    this.disable(date) ||
                    this.disableValidTo(date);
            }
        };
    },
    methods: {
        disableValidTo(date) {
            let hasTimeInterval = false;
            for (let i = 1; i < this.form.productTimeIntervals.length; i++) {
                if (this.$moment(date).toDate() > this.$moment(this.form.productTimeIntervals[i].validTo, "DD.MM.YYYY")) {
                    hasTimeInterval = true;
                }
                if (this.$moment(this.intervalForm.validFrom, "DD.MM.YYYY") > this.$moment(this.form.productTimeIntervals[i].validTo, "DD.MM.YYYY")) {
                    if (this.$moment(date).toDate() > this.$moment(this.form.productTimeIntervals[i].validTo, "DD.MM.YYYY")) {
                        hasTimeInterval = false;
                    }
                }
            }
            return hasTimeInterval;
        },
        disable(date) {
            let isBetween = false;
            for (let i = 1; i < this.form.productTimeIntervals.length; i++) {
                if (this.$moment(this.form.productTimeIntervals[i].validFrom, "DD.MM.YYYY") <= this.$moment(date).toDate() &&
                    this.$moment(this.form.productTimeIntervals[i].validTo, "DD.MM.YYYY").add(1, "day") > this.$moment(date).toDate()) {
                    isBetween = true;
                }
            }
            return isBetween;
        },
        deleteProductTimeInterval(index) {
            this.form.productTimeIntervals.splice(index, 1);
        },
        goToNextStep() {
            this.$v.form.$touch();
            if (!this.$v.form.$invalid) {
                const result = { ...this.form };
                result.productTimeIntervals = result.productTimeIntervals.filter((item) => item.validFrom);
                this.$emit("input", result);
                this.$emit("nextStep");
            }
        },
        addInterval() {
            this.$v.intervalForm.$touch();
            if (!this.$v.intervalForm.$invalid) {
                this.form.productTimeIntervals.push({
                    validFrom: this.$moment(this.intervalForm.validFrom).format("L"),
                    validTo: this.$moment(this.intervalForm.validTo).format("L")
                });
                this.addTimeInterval = !this.addTimeInterval;
                this.intervalForm = {
                    validFrom: null,
                    validTo: null
                };
                this.$v.intervalForm.$reset();
            }
        },
    },
    mounted() {
        this.$material.locale.firstDayOfAWeek = 1;
        this.$watch(() => this.value, newValue => {
            this.form = {
                productTimeIntervals: [
                    {},
                    ...this.value.productTimeIntervals
                ]
            };
        });
    },
    validations() {
        return {
            form: {
                productTimeIntervals: {},
            },
            intervalForm: {
                validFrom: {
                    required,
                    isSameOrBefore: isSameOrBefore("validTo"),
                    isSameOrAfterDate: isSameOrAfter(this.minDate)
                },
                validTo: {
                    required,
                    isSameOrAfter: isSameOrAfter("validFrom"),
                    isSameOrBeforeDate: isSameOrBefore(this.maxDate)
                }
            }
        };
    }
}
</script>

<style scoped lang="scss">
    @import "~vue-material/dist/theme/engine";
    @import "@/theme/_variables";

    .md-caption {
        color: md-get-palette-color(red, A200);
    }
    .add-interval-button{
        justify-content: flex-start;
    }
    .fixed-item-width {
        width: 10px;
    }
    .preferencesInfo{
        color: $color-mainFont;
        margin:15px 0 15px 0;
        text-align: center;
        font-size: 12px;
        display:grid;
        font-weight: normal;
        word-wrap: wrap;
    }
</style>
